import { getVisualAssetDefinition } from '../../visualAssets/catalog';

interface AssetImageRecord {
  image: HTMLImageElement;
  loaded: boolean;
  failed: boolean;
}

const assetImageCache = new Map<string, AssetImageRecord>();
const listeners = new Set<() => void>();

function notifyListeners(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function getVisualAssetImage(assetId: string): HTMLImageElement | null {
  const existing = assetImageCache.get(assetId);
  if (existing) {
    return existing.loaded && !existing.failed ? existing.image : null;
  }

  const definition = getVisualAssetDefinition(assetId);
  if (!definition) {
    return null;
  }

  const image = new Image();
  const record: AssetImageRecord = {
    image,
    loaded: false,
    failed: false,
  };

  image.onload = () => {
    record.loaded = true;
    notifyListeners();
  };
  image.onerror = () => {
    record.failed = true;
  };
  image.src = definition.imagePath;
  assetImageCache.set(assetId, record);
  return null;
}

export function invalidateVisualAssetImage(assetId?: string): void {
  if (typeof assetId === 'string') {
    assetImageCache.delete(assetId);
  } else {
    assetImageCache.clear();
  }
  notifyListeners();
}

export function subscribeToVisualAssetImageUpdates(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
